module.exports = __webpack_public_path__ + "static/media/TradePathways.1680987d.svg";